var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 60C22.25 60 19.8958 59.0208 17.9375 57.0625C15.9792 55.1042 15 52.75 15 50V30C15 27.25 15.9792 24.8958 17.9375 22.9375C19.8958 20.9792 22.25 20 25 20H55C57.75 20 60.1042 20.9792 62.0625 22.9375C64.0208 24.8958 65 27.25 65 30V50C65 52.75 64.0208 55.1042 62.0625 57.0625C60.1042 59.0208 57.75 60 55 60H25ZM25 30H55C55.9167 30 56.7917 30.1042 57.625 30.3125C58.4583 30.5208 59.25 30.8542 60 31.3125V30C60 28.625 59.5104 27.4479 58.5312 26.4688C57.5521 25.4896 56.375 25 55 25H25C23.625 25 22.4479 25.4896 21.4688 26.4688C20.4896 27.4479 20 28.625 20 30V31.3125C20.75 30.8542 21.5417 30.5208 22.375 30.3125C23.2083 30.1042 24.0833 30 25 30ZM20.375 38.125L48.1875 44.875C48.5625 44.9583 48.9375 44.9583 49.3125 44.875C49.6875 44.7917 50.0417 44.625 50.375 44.375L59.0625 37.125C58.6042 36.5 58.0208 35.9896 57.3125 35.5938C56.6042 35.1979 55.8333 35 55 35H25C23.9167 35 22.9688 35.2812 22.1562 35.8438C21.3438 36.4062 20.75 37.1667 20.375 38.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.0495b372cab2a197456c102970d3b67b.svg";
export { ForwardRef as ReactComponent };